module.exports = __webpack_public_path__ + "assets/img/law-enforcement.f6632d92.svg";